import axios from 'axios';
import Constants from '../constants';
import { IDisplayLogicEditModel } from '../models';

type SurveyQuestionDisplayLogicBatchEditModel = {
	[questionId: number]: IDisplayLogicEditModel[];
};

export async function UpdateQuestionDisplayLogic(surveyId: number, displayLogic: SurveyQuestionDisplayLogicBatchEditModel) {
	const url = getSurveyQuestionDisplayLogicApiUrl(surveyId);
	const res = await axios.put(url, displayLogic);
	return res.data;
}

export async function CreateQuestionDisplayLogic(surveyId: number, displayLogic: SurveyQuestionDisplayLogicBatchEditModel) {
	const url = getSurveyQuestionDisplayLogicApiUrl(surveyId);
	const res = await axios.post(url, displayLogic);
	return res.data;
}

export async function GetQuestionDisplayLogic(surveyId: number, ...questionIds: number[]) {
	const url = getSurveyQuestionDisplayLogicApiUrl(surveyId, ...questionIds);
	const res = await axios.get<SurveyQuestionDisplayLogicBatchEditModel>(url);
	return res.data;
}

export function getSurveyQuestionDisplayLogicApiUrl(surveyId: number, ...questionIds: number[]) {
	const url = new URL(Constants.DISPLAY_LOGIC_API.replace('{surveyId}', surveyId.toString()));
	questionIds.forEach((questionId) => url.searchParams.append('questionId', questionId.toString()));
	return url.toString();
}
